const step = (target, title, content, placement = 'bottom') => ({
  target,
  header: { title },
  content,
  params: {
    placement,
  },
})

export const buildCustomerChargesTour = ({
  t,
  canCreate,
  canManage,
  hasItems,
  hasPagination,
  isMobile,
}) => {
  const steps = [
    step(
      '[data-tour="charges-page"]',
      t('tutorials.customerCharges.introduction.title'),
      t('tutorials.customerCharges.introduction.content'),
    ),
    step(
      '[data-tour="charges-filters"]',
      t('tutorials.customerCharges.filters.title'),
      t('tutorials.customerCharges.filters.content'),
    ),
    step(
      isMobile
        ? '[data-tour="charges-mobile-list"]'
        : '[data-tour="charges-table"]',
      t('tutorials.customerCharges.results.title'),
      t(
        isMobile
          ? 'tutorials.customerCharges.results.mobileContent'
          : 'tutorials.customerCharges.results.desktopContent',
      ),
      'top',
    ),
  ]

  if (hasItems && canManage) {
    steps.push(
      step(
        isMobile
          ? '[data-tour="charges-mobile-actions"]'
          : '[data-tour="charges-desktop-actions"]',
        t('tutorials.customerCharges.actions.title'),
        t('tutorials.customerCharges.actions.content'),
        'left',
      ),
    )
  }

  if (!isMobile && hasPagination) {
    steps.push(
      step(
        '[data-tour="charges-pagination"]',
        t('tutorials.customerCharges.pagination.title'),
        t('tutorials.customerCharges.pagination.content'),
        'top',
      ),
    )
  }

  if (canCreate) {
    steps.push(
      step(
        '[data-tour="charges-create"]',
        t('tutorials.customerCharges.create.title'),
        t('tutorials.customerCharges.create.content'),
        'bottom',
      ),
    )
  }

  return steps
}

export const buildCustomerChargeFormTour = ({ t, mode }) => {
  const isReadOnly = mode === 'show'
  const steps = [
    step(
      '[data-tour="charge-form-page"]',
      t(`tutorials.customerCharges.form.${mode}.introductionTitle`),
      t(`tutorials.customerCharges.form.${mode}.introductionContent`),
    ),
    step(
      '[data-tour="charge-form-name"]',
      t('tutorials.customerCharges.form.fields.nameTitle'),
      t(
        isReadOnly
          ? 'tutorials.customerCharges.form.fields.nameReadOnlyContent'
          : 'tutorials.customerCharges.form.fields.nameContent',
      ),
      'bottom',
    ),
    step(
      '[data-tour="charge-form-description"]',
      t('tutorials.customerCharges.form.fields.descriptionTitle'),
      t(
        isReadOnly
          ? 'tutorials.customerCharges.form.fields.descriptionReadOnlyContent'
          : 'tutorials.customerCharges.form.fields.descriptionContent',
      ),
      'bottom',
    ),
  ]

  if (!isReadOnly) {
    steps.push(
      step(
        '[data-tour="charge-form-actions"]',
        t('tutorials.customerCharges.form.actions.title'),
        t(
          mode === 'create'
            ? 'tutorials.customerCharges.form.actions.createContent'
            : 'tutorials.customerCharges.form.actions.editContent',
        ),
        'top',
      ),
    )
  }

  steps.push(
    step(
      '[data-tour="charge-form-back"]',
      t('tutorials.customerCharges.form.back.title'),
      t('tutorials.customerCharges.form.back.content'),
      'bottom',
    ),
  )

  return steps
}
